<template>
  <div class="nsale_">
    <div>
      <div class="list_">
        <div
          class="item_"
          v-for="(item, index) in list"
          :key="index"
          @click="toPreview(index, item)"
        >
          <div class="item_1">
            <img class="item_1img" :src="item.imageNetContent" alt="poster" />
            <!-- <img class="code_" :src="codeUrl" alt="code" /> -->
          </div>
          <div class="item_2">
            <img class="item_2img" :src="defaultInfo.head" alt="code" />
            <div class="scale">
              <p class="txt txt1">{{ defaultInfo.name }}</p>
              <p class="txt txt2">{{ defaultDes }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="nullData_" v-if="list.length==0">没有数据哦</div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/beeApi";
export default {
  data() {
    return {
      nullTemp: false,
      appId: "", //商城id
      bullTemp: "",
      tempInfo: {
        tempName: ""
      },
      inviteUrl: "",
      userId: "",
      identify: "",
      codeUrl: "",
      defaultInfo: {
        name: "",
        head: ""
      },
      defaultDes: "欢迎使用my客蜂",
      list: [
      ]
    };
  },
  filters: {},
  mounted() {
    localStorage.removeItem('postInfo')
    this.hideOptionMenu();
    this.userId = this.$route.query.userId;
    this.getInvitationPoster()
    // let url = "http://114.55.172.103:8888/browse/MKF-95";
    // //测试
    // import("jr-qrcode").then(jrQrcode => {
    //   // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
    //   var imgBase64 = jrQrcode.getQrBase64(url);
    //   this.codeUrl = imgBase64;
    // });
  },
  methods: {
    hideOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("hideOptionMenu");
        }
      );
    },
    showOptionMenu() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function onBridgeReady() {
          WeixinJSBridge.call("showOptionMenu");
        }
      );
    },
    getInvitationPoster(){
      let data = {
        userId: this.userId
      }
      api.getInvitationPoster(data).then(res => {
        let content = res.data.content
        this.list = content.invitationPosterList
        this.defaultInfo = {
          name: content.name,
          head: content.headImage
        }
        this.defaultDes = content.loginName
      })
    },
    getUserDetailByUserId() {
      api.getUserDetailByUserId(this.userId).then(res => {
        this.defaultInfo = res.data.content;
      });
    },
    getRegisterLink() {
      return api
        .getRegisterLink()
        .then(res => res.data)
        .then(data => {
          return data.content;
        })
        .then(url => {
          this.inviteUrl = url;
          import("jr-qrcode").then(jrQrcode => {
            // 模块方法调用，传入字符串，获取 base64 编码的图片 URL
            var imgBase64 = jrQrcode.getQrBase64(url);
            this.codeUrl = imgBase64;
          });
        });
    },
    transformUrl(url) {
      console.log("url -> ", url);
      const pathname = new URL(url).pathname;
      let origin = window.location.origin
      const imgUrl = origin + pathname; // 转化后跨域的图片路径
      return imgUrl;
    },
    toPreview(index, item) {
      this.setInfo(item);
      this.$router.push({ name: "myBeePreview" });
    },
    setInfo(item) {
      let postInfo = {
        img: this.transformUrl(item.imageNetContent),
        head: this.transformUrl(this.defaultInfo.head),
        name: this.defaultInfo.name,
        // head: this.defaultInfo.head,
        // img: item.imageNetContent,
        des: this.defaultDes,
        // qrcode: this.codeUrl
      };
      localStorage.setItem("postInfo", JSON.stringify(postInfo));
    }
  }
};
</script>

<style scoped lang="scss">
.nsale_ {
  background: rgba(245, 245, 245, 1);
  min-height: 100vh;
  position: relative;
  .btn_ {
    width: 305px;
    height: 50px;
    background: rgba(255, 74, 53, 1);
    border-radius: 5px;
    margin: 40px auto 10px;
  }
  .head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    width: 100%;
    height: 60px;
    padding: 0 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head_ {
      font-size: 15px;
      color: rgba(51, 51, 51, 1);
      position: relative;
      .i_img {
        position: absolute;
        right: 10px;
        top: 12px;
        height: 7px;
        width: auto;
      }
    }
    .head_2 {
      width: 160px;
      height: 30px;
      background: #f5f5f5;
      border-radius: 5px;
      display: flex;
      align-items: center;
    }
    .head_3 {
      width: 100px;
      height: 30px;
      line-height: 30px;
      background: rgba(255, 74, 53, 1);
      border-radius: 5px;
      font-size: 13px;
      color: rgba(255, 255, 255, 1);
    }
  }

  .list_ {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: .213333rem;
    /* text-align: left; */
    justify-content: flex-start;
    .item_ {
      width: 32%;
      margin-right: 0.1rem;
      margin-bottom: 10px;
      border-radius: 5px 5px 0 0;
      overflow: hidden;
      .item_1 {
        width: 100%;
        height: 176px;
        position: relative;
        .item_1img {
          width: 100%;
          height: 100%;
        }
        .code_ {
          position: absolute;
          right: 7%;
          bottom: 7%;
          height: 23px;
          width: auto;
        }
        .saveTip {
          width: 100%;
          height: 20px;
          line-height: 20px;
          background: rgba(0, 0, 0, 1);
          opacity: 0.4;
          position: absolute;
          bottom: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 12px;
            color: rgba(255, 255, 255, 1);
            opacity: 0.5;
            // transform: scale(0.7, 0.7);
          }
        }
      }
      .item_2 {
        border-radius: 0 0 5px 5px;
        background: url("../../../assets/image/newbee/bottom.png") no-repeat;
        background-size: 100% 100%;
        height: 50px;
        display: flex;
        align-items: center;
        font-size: 6px;
        color: rgba(102, 102, 102, 1);
        .scale {
          margin-left: 5px;
          width: 70%;
        }
        .item_2img {
          border-radius: 50%;
          margin-left: 5px;
          width: 30%;
          height: auto;
        }
        .txt {
          text-align: left;
          font-size: 6px;
        }
        .txt1 {
          margin-bottom: 4px;
          font-weight: bold;
          font-size: 6px;
        }
        .txt2 {
          margin: 0 6px 0 0;
        }
      }
    }
  }

  .null_ {
    padding-top: 70px;
    font-size: 13px;
    color: rgba(153, 153, 153, 1);
    img {
      height: 130px;
      width: auto;
    }
    .nullTxt {
      width: 246px;
      line-height: 20px;
      margin: 10px auto 0;
    }
  }
  .null_1 {
    margin: 0 auto;
    padding-top: 0;
    width: 345px;
    height: 345px;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .nullTxt1 {
      font-size: 17px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }

    .nullData_ {
    margin: 0.52rem auto;
    font-size: 0.29rem;
    color: rgba(153, 153, 153, 1);
  }
}
</style>
